<template>
<div class="pageForm__content"
  :data-free="isFree"
  :data-loading="isLoading"
>
  <div class="card__backdrop"></div>
  <app-loading class="card__loading" :is-loading="isLoading"></app-loading>
  <div class="pageForm__summary">SUMMARY</div>
  <div class="pageForm__menu-title u-tx-black">{{ itemName }}</div>

  <div ref="resultArea" class="trial__result" v-show="hasTrialResult">
    <h4 class="u-tx-center u-tx-brand">{{ displayNickname }}さんの結果は…</h4>
    <div v-for="result in results.result_data" :key="result.title" class="resultContent">
      <p v-if="result.text1" v-html="result.text1"></p>
      <p v-if="result.text2" v-html="result.text2"></p>
      <p v-if="result.text3" v-html="result.text3"></p>
    </div>
    <share-buttons v-if="false"></share-buttons>
  </div>

  <div class="pageForm__area">
    <div class="loadingArea"></div>
    <form
      ref="form"
      scope="trialForm"
      @submit="handleSubmit"
    >
      <form-input
        v-model="input.nickname"
        data-layout="row"
        label="ニックネーム"
        name="nickname"
        :validation="{ rules: {
          required: true,
          max: 15
        } }"
      ></form-input>

      <form-input
        v-if="inputParam.last_name"
        v-model="input.last_name"
        data-layout="row"
        label="姓(漢字)"
        name="last_name"
        :validation="{ rules: {
          required: true,
          max: 15
        } }"
      ></form-input>

      <form-input
        v-if="inputParam.first_name"
        v-model="input.first_name"
        data-layout="row"
        label="名(漢字)"
        name="first_name"
        :validation="{ rules: {
          required: true,
          max: 15
        } }"
      ></form-input>


      <form-date
        v-if="inputParam.birthday"
        v-model="input.birthday"
        data-layout="row"
        label="生年月日"
        name="birthday"
        :validation="{ rules: {
          required: true,
          birthRange: true
        } }"
      ></form-date>

      <toggle-unknown
        label="生まれた時間"
        name="birthtime"
        :unknown-value="BIRTHTIME_UNKNOWN_VALUE"
        data-layout="row"
        v-model="input.birthtimeUnknown"
        v-if="inputParam.birthtime === 1">
        <template slot-scope="props">
          <form-time
            style="width: 128px"
            v-model="input.birthtime"
            name="birthtime"
          ></form-time>
        </template>
      </toggle-unknown>
      <input type="hidden" v-if="inputParam.birthtime === 2" name="birthtime" value="0000">

      <form-select
        v-if="inputParam.from_pref === 1"
        v-model="input.from_pref"
        data-layout="row"
        label="生まれた場所"
        name="from_pref"
        :options="inputParams.from_pref"
      ></form-select>
      <input type="hidden" v-if="inputParam.from_pref === 2" name="from_pref" value="その他">

    </form>
    <button class="btn u-mg-t-2"
      type="submit"
      data-color="pink_active"
      data-block="true"
      @click.prevent="handleSubmit"
    >占う</button>
  </div>
</div>
</template>

<script>
import mixins from './mixins'

export default {
  name: 'story-summary',
  mixins: [mixins]
}</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/StorySummary.vue